import { useState } from "react";
import { IconButton, Tooltip, Typography } from "@mui/material";
import { BCPCircleQuestion } from "../icons/bcp/BCPIcons";

export default function HelpButton(props) {
  const { title, iconButtonSX, iconSX } = props;
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setOpen(true);
  };

  return (
    <Tooltip
      title={toolTipTitle(title)}
      onClose={handleTooltipClose}
      open={open}
    >
      <IconButton
        onClick={handleTooltipOpen}
        sx={{ ml: "8px", ...iconButtonSX }}
      >
        <BCPCircleQuestion sx={iconSX} />
      </IconButton>
    </Tooltip>
  );
}

function toolTipTitle(title) {
  if (typeof title !== "string") {
    return title;
  }
  return (
    <>
      {title
        ?.replaceAll("\\n", "\n")
        ?.split("\n")
        ?.map((titleLine, index) => (
          <Typography
            variant="caption"
            key={index}
            paragraph
            sx={{ mb: "unset" }}
          >
            {titleLine}
          </Typography>
        ))}
    </>
  );
}
